import React, {useLayoutEffect, useRef, useState, useContext, useEffect} from 'react'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import FormFields from './FormFields'
import UserItem from './UserItem'
import styles from './InventoryForm.module.css'
import {Row, Button} from 'react-bootstrap'

function UsersItems(props) {

    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext)

    const fields = FormFields()
    const scrollable = useRef()
    const scrollToRef = useRef()
    

    const [inventoryItems, setInventoryItems] = useState([])

    // console.log("Users Items props", props)

    // const getUserInventoryItems = async () => {
    //     const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventories/inventories_by_user/me` : `${process.env.REACT_APP_API_URL_PROD}iinventories/inventories_by_user/me`
    //     await fetch(url, {
    //         method: 'GET',
    //         headers: {
    //             Authorization: `${userCtx.token_type} ${userCtx.jwt}`
    //         }
    //     })
    //         .then((response) => response.json())
    //         .then(data => {
                
    //             if (!!data) {
    //                 console.log("inventories", data)
    //                 setInventoryItems(data)
    //             }
    //         })
    //         .catch(e => console.log("error getting user's invemtory items", e))
    // }

    const adjustItemsListHeight = () => {
        // calculate size of the table
        const html = document.getElementsByTagName("html");
        if (!!html) {
            // console.log("html", html)
            const htmlHeight = html[0].clientHeight;

            // const tbl = document.getElementById('inventory_container');
            const tbl = scrollable.current;
            // console.log("scrollable", tbl)
            if (!!tbl) {
                const rect = tbl.getBoundingClientRect()
                // console.log("Scrollable position", rect )

                // calculate height
                const tblHeight = htmlHeight - rect.top - 70;
                // console.log("Scrollable new height", tblHeight )
                tbl.style.height = `${tblHeight}px`
            }

        }
    }




    useEffect(() => {
        // getUserInventoryItems()
        // console.log("Use Effect props.inventoryItems", props.inventoryItems)
        setInventoryItems(props.inventoryItems)
    },[props.inventoryItems])


    useEffect(() => {
        // getUserInventoryItems()
        // console.log("Use Effect props.inventoryItems", props.inventoryItems)
        // console.log("Use Effect props.scrollToId", props.scrollToId)
        if (!!props.scrollToId) {
            setTimeout(() => {
                const itemElement = document.getElementById(props.scrollToId.toUpperCase());
                if (!!itemElement) {
                    itemElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 400)
        }
    },[props.scrollToId])


    useEffect(() => {
        const handleWindowResize = () => {
            adjustItemsListHeight();
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
    }, []);


    useLayoutEffect(() => {
        adjustItemsListHeight();
    })




    return (
        <>
            <div className='mx-3'>
                <div className={`${styles.inventory_list_container} mx-auto`} ref={scrollable}>
                    {inventoryItems.length > 0 && inventoryItems.map((item,ix) => {
                        if(!!props.scrollToId && props.scrollToId  === item.id) {
                            return (<UserItem isSelected={props.selectedItems.includes(item.id)} ref={scrollToRef} id={item.id} mode={props.mode} item={item} key={ix} unique_ix={ix} onItemSelect={props.onItemSelect}/>)
                        } else {
                            return (<UserItem id={item.id} isSelected={props.selectedItems.includes(item.id)} mode={props.mode} item={item} key={ix} unique_ix={ix} onItemSelect={props.onItemSelect}/>)
                        }
                        
                    })}
                </div>
            </div>
        </>
    )
}

export default UsersItems
